import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import Icon, { IconTheme, IconVariant } from 'src/components/ui-kit/icon/icon';
import Table from 'src/components/ui-kit/table/table';
import TableCell from 'src/components/ui-kit/table/_cell';
import TableRow from 'src/components/ui-kit/table/_row';
import Button, { ButtonSize } from 'src/components/ui-kit/button/button';
import styles from './table-documents.module.scss';
import { Media } from 'src/entities/media';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import Box, { HeaderTheme } from 'src/components/ui-kit/box/box';
import Link from 'next/link';

const classesContext = classNames.bind(styles);

export default function ListingsTableDocuments({
  documents,
  listingId,
  linkArchive,
  className,
  isDownloadable,
  ...restProps
}: {
  documents: Array<Media>;
  listingId: number;
  linkArchive: string;
  isDownloadable: boolean;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  const { t } = useTranslation('components:pages:listings:view:documents');

  const transformByteToMegabyte = (byte: number): string => (byte / 1024 / 1024).toFixed(2);

  const transformListingFileName = (name: string): string => name.replace(/listing.[0-9]*[\s\S|\S]\S/gi, '')
    .trim();

  return (
    <Box
      className={className}
      heading={t('TEXT_DOCUMENTATION')}
      headingTheme={HeaderTheme.DARK}
      {...restProps}>
      <Table className={styles.table}>
        <TableRow
          isHeader
          className={styles.table_row}>
          <TableCell className={classesContext(styles.table_cell__header, styles.table_cell__name)}>
            {t('TEXT_FILE_NAME')}
          </TableCell>
          <TableCell className={classesContext(styles.table_cell__header, styles.table_cell__size)}>
            {t('TEXT_FILE_SIZE')}
          </TableCell>
        </TableRow>
        {documents.map((file) => (
          <TableRow key={file.name}>
            <TableCell className={classesContext([styles.table_cell, styles.table_cell__name])}>
              {transformListingFileName(file.name)}
            </TableCell>
            <TableCell className={classesContext([styles.table_cell, styles.table_cell__size])}>
              {transformByteToMegabyte(file.size)} Mb
            </TableCell>
          </TableRow>
        ))}
      </Table>
      {isDownloadable && (
        <Link href={linkArchive}>
          <Button
            className={styles.table_button}
            size={ButtonSize.LARGE}>
            <Icon
              variant={IconVariant.ARCHIVE}
              theme={IconTheme.WHITE} />
            {t('BUTTON_DOWNLOAD')}
          </Button>
        </Link>
      )}
    </Box>
  );
}
